module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/arquivo-sia/arquivo-sia.component.css
// module id = ./src/app/arquivo-sia/arquivo-sia.component.css
// module chunks = main